export default import.meta.ROLLDOWN_FILE_URL_I6hx7W5SDBZbqzNeMIi0Yw